Bacon = require 'baconjs'
React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
ReactDOM = require 'react-dom'

import ErrorBoundary, { DefaultFallbackComponent,addBugsnagMetadataObserver } from 'utils/bugsnag'

ReactBacon = require 'react-bacon'
R = require 'ramda'

cx = require 'classnames'

Navbar = require 'app/common/navbar'
Order = require './order-meta'
Customer = require './customer'
Restaurant = require 'app/common/restaurant'
Subject = require './subjects'

ReactGlobalize = require 'react-globalize'
Globalize = require 'globalize'

# makeReceipt = require './receipt'

{ FormatMessage } = ReactGlobalize

{ errorReporter } = require 'utils/errors'

feedbackStore = require 'stores/feedback'
restaurantStore = require 'stores/restaurant'

renderQuestion = R.curry (activeQuestion, onActivate,  question) ->
  <Subject.Question question={question} onActivate={R.partial(onActivate, [question])} isActive={activeQuestion is question} />

renderReview = (review) ->
  <Subject.Review review={review} />

ecommerce = require 'stores/ecommerce'

App = createReactClass
  displayName: 'App'

  mixins: [ReactBacon.BaconMixin]

  props:
    order: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired
    restaurant: PropTypes.object.isRequired

  getInitialState: ->
    questions: []
    activeQuestion: null
    reviews: []
    session: {}
    pdfProcessing: false

  componentDidMount: ->
    @plug feedbackStore.feedbackSession, 'session'
    @plug feedbackStore.feedbackQuestionSubjects, 'questions'
    @plug feedbackStore.feedbackReviewSubjects, 'reviews'
    @cancelActiveQuestionSubscription = feedbackStore.feedbackQuestionSubjects.onValue (subjects) =>
      subject = R.find R.pipe(R.prop('rating'), R.isNil), subjects
      @setState activeQuestion: subject if subject

  componentWillUnmount: ->
    @cancelActiveQuestionSubscription()

  onActivateQuestion: (question) ->
    @setState activeQuestion: question

  onDownloadReceipt: ->
    return if @state.pdfProcessing
    @setState pdfProcessing: true

    setTimeout =>
      makeReceipt @props.order, @props.locale.formatCurrency, (receipt) =>
        # receipt.getDataUrl (pdf) => @setState pdf: pdf
        receipt.download(@props.order.id)
        @setState pdfProcessing: false
    , 0

  closeSession: ->
    feedbackStore.closeSession()

  renderDownloadReceipt: ->
    <button type="button" className="btn btn-default btn-xs pull-right"
      onClick={@onDownloadReceipt} title={Globalize.formatMessage(downloadLabel)}>
      <span className="glyphicon glyphicon-download-alt"></span>
    </button>

  render: ->
    closeButtonClassName = cx 'row', 'hidden': !!@state.session.closed

    downloadLabel = if @state.pdfProcessing
      "order.receipt.processing"
    else
      "order.receipt.label"

    <div>
      <ErrorBoundary FallbackComponent={DefaultFallbackComponent}>
        <Navbar user={@props.order.customer} />
        <div className="container">
          <div className="row brief-section">
            <div className=" col-xs-12 col-md-5 col-sm-12">
              <Restaurant restaurant={@props.restaurant} serviceId={@props.order.service.id} orderId={@props.order.id}  />
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <Order.State order={@props.order} />
            </div>

            <div className="col-xs-6 col-md-2">
              <Order.Confirmation order={@props.order} />
            </div>

            <div className="col-xs-6 col-md-2">
              <Order.Total order={@props.order} locale={@props.locale}/>
            </div>
          </div>

          <div className="row main-section">
            <div className="col-sm-12 col-md-8">
              <span className="box-info">
                <FormatMessage>order.summary.entry</FormatMessage>
              </span>
              <Order.Summary order={@props.order} locale={@props.locale} />
            </div>

            <div className="col-sm-12 col-md-4">
              <Order.Reserved order={@props.order} locale={@props.locale} />
              <Customer.Marketing order={@props.order} locale={@props.locale} />
              <Order.Favorite order={@props.order} locale={@props.locale} />
              <Order.Bonus order={@props.order} locale={@props.locale} />
              { @state.questions.map renderQuestion(@state.activeQuestion, @onActivateQuestion) }
              { @state.reviews.map renderReview }
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </div>

appStream = Bacon
  .combineTemplate
    order: feedbackStore.order
    locale: restaurantStore.locale
    restaurant: restaurantStore.restaurant

feedbackStore
  .order
  .take 1
  .onValue ecommerce.recordPurchase

addBugsnagMetadataObserver Bacon.constant(window.page_config), 'PageConfig'
addBugsnagMetadataObserver appStream, 'PaymentContext'

appStream.onValue (appData) ->
  ReactDOM.render <App {...appData} />, document.getElementById 'app-container'

feedbackStore
  .orderError
  .onValue (error) ->
    # renderApp <div>
    #     <h3>Could not load order details.</h3>
    #     <p>{error}</p>
    #     <p>Order: {window.page_config.ORDER_UUID}</p>
    #   </div>

paymentsErrorReporter = errorReporter("Feedback Client Error")
appStream.onError paymentsErrorReporter

feedbackStore.openOrder window.page_config.ORDER_UUID

module.exports = App
